module.exports = __webpack_public_path__ + "media/images/countryrect/mh-73da64832df67b7b73bfb5b88702befb.svg";